module.exports = __webpack_public_path__ + "img/payment-promotion.d990fce.png";